/**
 * Legacy DROPS semantic names mapped to the status colors supported by Spor.
 */
export type SemanticValue =
  | "alarm"
  | "secondaryAlarm"
  | "warning"
  | "info"
  | "success"
  | "neutral"
  | "special"
  | "system"
  | "transparent"
  | "transparentInverted"
  | "ghost";

export type SporDataColor =
  | "success"
  | "info"
  | "warning"
  | "caution"
  | "critical"
  | "neutral"
  | "notice"
  | "service";

export const semanticToDataColor = (semantic: SemanticValue): SporDataColor => {
  switch (semantic) {
    case "alarm":
      return "critical";
    case "secondaryAlarm":
      return "caution";
    case "warning":
      return "warning";
    case "info":
      return "info";
    case "success":
      return "success";
    case "ghost":
      return "neutral";
    case "neutral":
    case "special":
    case "system":
    case "transparent":
    case "transparentInverted":
      return "neutral";
  }
};
